export default __webpack_public_path__ + "partner_32a5963.png";